import {
  uploadClaimDocument,
  type ClaimRegisterDocument,
} from "@tm/insurance/api";

function extensionOf(fileName: string): string {
  const ext = fileName.split(".").pop();
  return ext && ext !== fileName ? ext.toLowerCase() : "";
}

export async function uploadClaimFile(
  file: File,
  fieldName: string,
  bookingId: string,
  partnerBookingId?: string
): Promise<ClaimRegisterDocument> {
  const result = await uploadClaimDocument({
    file,
    fieldName,
    bookingId,
    ...(partnerBookingId ? { partnerBookingId } : {}),
  });

  return {
    name: file.name,
    id: result.documentId,
    url: result.key,
    extension: result.extension || extensionOf(file.name),
    category: result.fieldName || fieldName,
  };
}
